import { QueryKey, useQuery } from "@tanstack/react-query";

import { getClient } from "services";

export const EQ_COURSE_SECTIONS_QUERY_KEY = "short-answer-eq-course-sections";

export default function useEQCourseSections(
  args: {
    courseId?: string;
    sectionId?: string;
  },
  { enabled }: { enabled: boolean } = { enabled: true }
) {
  return useQuery({
    queryKey: [EQ_COURSE_SECTIONS_QUERY_KEY, args] as QueryKey,
    queryFn: () => getClient("shortAnswerService").queryCourseSections(args),
    enabled: !!args.courseId && enabled,
    staleTime: Infinity,
    retry: failureCount => failureCount < 3
  });
}
